module.exports = __webpack_public_path__ + "img/Menu-03.185869be.png";